import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessDaysService {
  constructor(
    @Inject('env') private env: any,
    private http: HttpClient
  ) {}

  public getBusinessDay(initialDate: Date, offset: number) {
    //If the offset is 0, then we don't need to do any math.
    //Today /is/ the next available business day. Short-circuiting
    //The request
    if (offset === 0 || offset == null) {
      return of(initialDate);
    }

    let params = new HttpParams();
    params = params.set('initialDate', new Date(initialDate).toISOString());
    params = params.set('offset', offset);

    return this.http
      .get<{ Result: string }>(`${this.env.apiUrlRoot}/NextBusinessDays`, { params: params })
      .pipe(
        map(result => {
          return new Date(Date.parse(result.Result));
        })
      );
  }
}
